'use client';
import dynamic from 'next/dynamic';
const MediaQuery = dynamic(() => import('react-responsive'), {
    ssr: false,
});

export const Desktop = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
    return <MediaQuery minWidth={768}>{children}</MediaQuery>;
};
export const TabletAndBelow = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
    return <MediaQuery maxWidth={1023}>{children}</MediaQuery>;
};
export const Mobile = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
    return <MediaQuery maxWidth={767}>{children}</MediaQuery>;
};
